import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const ApprovedIcon = createIcon({
  displayName: 'ApprovedIcon',
  path: <path d="M17.355 7l-7.688 7.688-3.022-3.01L5 13.323l4.667 4.667L19 8.657 17.355 7z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
